import { motion } from "framer-motion";
import { useLanguage } from "../../hooks/useLanguage";

const buildStatusStep = (step, currentStep) => {
  return currentStep === step
    ? "active"
    : currentStep < step
    ? "inActive"
    : "complete";
};

function ForwardNext() {
  const { currentLanguage } = useLanguage();
  return (
    <div className=" w-full h-0.5 flex justify-center items-center stroke-primary-200">
      <svg
        className="w-full"
        viewBox="0 0 100 10"
        xmlns="http://www.w3.org/2000/svg"
      >
        <motion.path
          // initial={{ pathLength: 0 }}
          // animate={{ pathLength: 1 }}
          initial={{
            ...(currentLanguage === "ar"
              ? {
                  pathOffset: 1,
                  pathLength: 1,
                }
              : {
                  pathLength: 0,
                }),
          }}
          animate={{
            pathLength: 1,
            ...(currentLanguage === "ar" ? { pathOffset: 0 } : {}),
          }}
          transition={{
            duration: 0.2,
            ease: "easeInOut",
          }}
          strokeWidth={0.5}
          d="M 0, 5 L 100, 5"
        />
      </svg>
    </div>
  );
}

const Step = ({ step, currentStep, item }) => {
  const status = buildStatusStep(step, currentStep);

  return (
    <div className="relative ">
      <div className="relative">
        <motion.div
          animate={status}
          transition={{ delay: 0.1, duration: 0.4 }}
          variants={{
            active: {
              scale: 1.25,
              opacity: 0,
            },
            inActive: {
              scale: 1,
              opacity: 1,
              background: "Silver",
            },
          }}
          className="absolute inset-0 rounded-full bg-primary-200 "
        />
        <motion.div
          initial={{
            background:
              status === "active"
                ? "linear-gradient(118.98deg, #ED4690 -2.11%, #5522CC 63.58%)"
                : "Silver",
          }}
          transition={{
            duration: 0.1,
            delay: 0.2,
            type: "tween",
            ease: "circInOut",
          }}
          className={`relative flex items-center justify-center w-6.5 h-6.5 border rounded-full font-bold text-body-2 lg:w-8 lg:h-8 lg:text-body-1`}
          animate={status}
          variants={{
            active: {
              background:
                "linear-gradient(118.98deg, #ED4690 -2.11%, #5522CC 63.58%)",
            },
            inActive: {
              background:
                "linear-gradient(0deg, #E6E3EC 100%, #E6E3EC 100%, #E6E3EC 100%)",
            },
            complete: {
              background:
                "linear-gradient(118.98deg, #ED4690 -2.11%, #5522CC 63.58%)",
            },
          }}
        >
          <motion.div
            initial={{ color: "#9892A6" }}
            animate={status}
            variants={{
              active: {
                color: "white",
              },
              inActive: {
                color: "#9996A0",
              },
              complete: {
                color: "white",
              },
            }}
          >
            {step + 1}
          </motion.div>
        </motion.div>
        <motion.div
          className="absolute flex flex-row justify-center top-7 text-center w-20 sm:w-32 sm:-left-12 md:w-40 md:-left-16 -left-7 text-body-3 md:font-bold md:text-body-2 lg:text-body-1 lg:top-9 text-primary-100"
          initial={{ color: "#9996A0" }}
          animate={status}
          variants={{
            active: {
              color: "#6F24EA",
            },
            inActive: {
              color: "#9892A6",
            },
            complete: {
              color: "#6F24EA",
            },
          }}
        >
          {item.title}
        </motion.div>
      </div>
    </div>
  );
};

export const StepWithDivide = ({ item, step, currentStep, totalStep }) => {
  const status = buildStatusStep(step, currentStep);

  return (
    <div
      className={` relative flex flex-row items-center ${
        step === totalStep - 1 ? "w-auto" : "w-full"
      }`}
    >
      <Step step={step} currentStep={currentStep} item={item} />
      {step < totalStep - 1 && status === "complete" && <ForwardNext />}
      {step < totalStep - 1 &&
        (status === "inActive" || status === "active") && (
          <div className="relative w-full h-0.5 bg-[#E6E3EC]"></div>
        )}
    </div>
  );
};
